import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { initializeMocksListenerSaga } from './initialize';

export function* rootSaga(): SagaIterator {
    yield all([fork(initializeMocksListenerSaga)]);
}
